// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectboxwidth{
    width: 200px;
}

.unsettledPageHeader {
  width: 100%;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
  border-radius: 22px;
  padding: 24px;
  margin-bottom: 24px;
}

.unsettledPageHeaderTop {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
}

.unsettledPageTitle {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #111827;
}

.unsettledPageSubtitle {
  margin: 6px 0 0;
  font-size: 14px;
  color: #6b7280;
}

.unsettledActions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  width: 100%;
}

.unsettledSearchGroup {
  min-width: 260px;
  width: 100%;
  max-width: 420px;
}

.unsettledSearchInput,
.unsettledSelect {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 12px;
  padding: 12px 16px;
  background: #f8fafc;
  color: #111827;
  outline: none;
  box-shadow: none;
}

.unsettledButtonSecondary,
.unsettledButtonPrimary {
  border-radius: 12px;
  padding: 11px 18px;
  font-weight: 600;
  transition: all 0.2s ease;
  cursor: pointer;
  white-space: nowrap;
}

.unsettledButtonSecondary {
  background: #f8fafc;
  border: 1px solid #d1d5db;
  color: #111827;
}

.unsettledButtonSecondary:hover {
  background: #edf2f7;
}

.unsettledButtonPrimary {
  background: #fb7d2d;
  border: none;
  color: #ffffff;
}

.unsettledButtonPrimary:hover {
  background: #ea6d19;
}

.unsettledCard {
  width: 100%;
  background: #ffffff;
  border-radius: 22px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
  overflow: hidden;
}

.unsettledTableWrapper {
  width: 100%;
  max-height: 65vh;
  overflow: auto;
  background: transparent;
  padding: 20px;
}

.unsettledTableWrapper .custom-table {
  min-width: 900px;
  border-collapse: separate;
  border-spacing: 0 10px;
}

.unsettledTableWrapper .custom-table th {
  padding: 18px 16px;
  text-align: left;
  font-size: 14px;
  color: #111827;
  font-weight: 700;
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
}

.unsettledTableWrapper .custom-table td {
  padding: 18px 16px;
  vertical-align: middle;
  background: #ffffff;
  color: #374151;
}

.unsettledTableWrapper .custom-table tr {
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04);
  border-radius: 18px;
}

.unsettledTableWrapper .custom-table tr:hover td {
  background: #f8fafc;
}

.unsettledTableWrapper .custom-table td:first-child {
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}

.unsettledTableWrapper .custom-table td:last-child {
  border-top-right-radius: 18px;
  border-bottom-right-radius: 18px;
}

.unsettledMobileCard {
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  background: #ffffff;
  padding: 18px;
  margin-bottom: 16px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04);
}

.unsettledMobileCard .genericlabel {
  font-weight: 600;
  color: #111827;
}

.unsettledMobileCard .unsettledViewButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #fb7d2d;
  color: #ffffff;
  border-radius: 16px;
  padding: 10px 16px;
  cursor: pointer;
  font-weight: 700;
  border: none;
}

@media screen and (max-width: 1024px) {
  .unsettledPageHeaderTop {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media screen and (max-width: 768px) {
  .unsettledPageHeader,
  .unsettledCard {
    padding: 16px;
  }

  .unsettledActions {
    flex-direction: column;
    align-items: stretch;
  }

  .unsettledSearchGroup,
  .unsettledSelect,
  .unsettledButtonSecondary,
  .unsettledButtonPrimary {
    width: 100%;
  }

  .unsettledTableWrapper {
    padding: 12px;
  }

  .unsettledTableWrapper .custom-table {
    min-width: auto;
  }
}

@media screen and (max-width: 480px) {
    .selectboxwidth{
        width: 291px;
    }

    .widthControl{
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/unsettledTransaction/unsettledTransaction.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;;;IAIE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".selectboxwidth{\n    width: 200px;\n}\n\n.unsettledPageHeader {\n  width: 100%;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);\n  border-radius: 22px;\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n.unsettledPageHeaderTop {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.unsettledPageTitle {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.unsettledPageSubtitle {\n  margin: 6px 0 0;\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.unsettledActions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.unsettledSearchGroup {\n  min-width: 260px;\n  width: 100%;\n  max-width: 420px;\n}\n\n.unsettledSearchInput,\n.unsettledSelect {\n  width: 100%;\n  border: 1px solid #d1d5db;\n  border-radius: 12px;\n  padding: 12px 16px;\n  background: #f8fafc;\n  color: #111827;\n  outline: none;\n  box-shadow: none;\n}\n\n.unsettledButtonSecondary,\n.unsettledButtonPrimary {\n  border-radius: 12px;\n  padding: 11px 18px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.unsettledButtonSecondary {\n  background: #f8fafc;\n  border: 1px solid #d1d5db;\n  color: #111827;\n}\n\n.unsettledButtonSecondary:hover {\n  background: #edf2f7;\n}\n\n.unsettledButtonPrimary {\n  background: #fb7d2d;\n  border: none;\n  color: #ffffff;\n}\n\n.unsettledButtonPrimary:hover {\n  background: #ea6d19;\n}\n\n.unsettledCard {\n  width: 100%;\n  background: #ffffff;\n  border-radius: 22px;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.08);\n  overflow: hidden;\n}\n\n.unsettledTableWrapper {\n  width: 100%;\n  max-height: 65vh;\n  overflow: auto;\n  background: transparent;\n  padding: 20px;\n}\n\n.unsettledTableWrapper .custom-table {\n  min-width: 900px;\n  border-collapse: separate;\n  border-spacing: 0 10px;\n}\n\n.unsettledTableWrapper .custom-table th {\n  padding: 18px 16px;\n  text-align: left;\n  font-size: 14px;\n  color: #111827;\n  font-weight: 700;\n  background: #f8fafc;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.unsettledTableWrapper .custom-table td {\n  padding: 18px 16px;\n  vertical-align: middle;\n  background: #ffffff;\n  color: #374151;\n}\n\n.unsettledTableWrapper .custom-table tr {\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04);\n  border-radius: 18px;\n}\n\n.unsettledTableWrapper .custom-table tr:hover td {\n  background: #f8fafc;\n}\n\n.unsettledTableWrapper .custom-table td:first-child {\n  border-top-left-radius: 18px;\n  border-bottom-left-radius: 18px;\n}\n\n.unsettledTableWrapper .custom-table td:last-child {\n  border-top-right-radius: 18px;\n  border-bottom-right-radius: 18px;\n}\n\n.unsettledMobileCard {\n  border: 1px solid #e5e7eb;\n  border-radius: 18px;\n  background: #ffffff;\n  padding: 18px;\n  margin-bottom: 16px;\n  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.04);\n}\n\n.unsettledMobileCard .genericlabel {\n  font-weight: 600;\n  color: #111827;\n}\n\n.unsettledMobileCard .unsettledViewButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #fb7d2d;\n  color: #ffffff;\n  border-radius: 16px;\n  padding: 10px 16px;\n  cursor: pointer;\n  font-weight: 700;\n  border: none;\n}\n\n@media screen and (max-width: 1024px) {\n  .unsettledPageHeaderTop {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .unsettledPageHeader,\n  .unsettledCard {\n    padding: 16px;\n  }\n\n  .unsettledActions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .unsettledSearchGroup,\n  .unsettledSelect,\n  .unsettledButtonSecondary,\n  .unsettledButtonPrimary {\n    width: 100%;\n  }\n\n  .unsettledTableWrapper {\n    padding: 12px;\n  }\n\n  .unsettledTableWrapper .custom-table {\n    min-width: auto;\n  }\n}\n\n@media screen and (max-width: 480px) {\n    .selectboxwidth{\n        width: 291px;\n    }\n\n    .widthControl{\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
